import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function FeaturedGuides() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-12">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-secondary-700 bg-secondary-100 rounded-full">
            Latest Guides
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 tracking-tight leading-tight">
            Superbuy Sheet{' '}
            <span className="text-accent-600">Resources</span>
          </h2>
          <p className="mt-3 text-foreground-500 text-base max-w-xl">
            In-depth articles, tutorials, and guides to help you master product discovery with Superbuy Sheet.
          </p>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="block break-inside-avoid bg-background-50 rounded-xl border border-background-200/70 hover:border-accent-200/60 hover:bg-accent-50/50 p-6 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 rounded-full bg-secondary-100 flex-shrink-0 flex items-center justify-center">
                  <i className="ri-file-text-line text-lg text-secondary-600"></i>
                </div>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 leading-snug">
                    {article.title}
                  </h3>
                  <span className="inline-block mt-1.5 text-xs text-accent-600 font-medium">
                    {article.category}
                  </span>
                </div>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {article.excerpt}
              </p>
              <div className="mt-4 flex items-center justify-between text-xs text-foreground-400">
                <span>{article.readTime}</span>
                <span>{article.date}</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/article/superbuy-sheet-complete-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Start Reading
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}